import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";
import classNames from "classnames";
import { useCallback, useContext } from "react";
import { FormContext } from "../FormContext";

type IProps = {
	name: string;
	value: string;
	label?: string;
	additionalInfo?: string;
	required?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	checked?: boolean;
};

export default function Radio(props: IProps) {
	const context = useContext(FormContext);
	let errors = context?.getMessagesErrors(props.name);
	const hasErrors = errors?.length > 0;

	const onWheel = useCallback((event: React.WheelEvent<HTMLInputElement>) => {
		(event.target as HTMLInputElement).blur();
	}, []);

	return (
		<div className={classNames(classes["root"], props.className)}>
			<div className={classes["input-container"]}>
			<input
				id={props.value}
				onWheel={onWheel}
				name={props.name}
				type={"radio"}
				required={props.required}
				value={props.value}
				onChange={props.onChange}
				className={classes["input"]}
				checked={props.checked}
			/>
			{props.label && (
				<label htmlFor={props.value} className={classes["label"]}>
					<Typography type="span" weight="regular" size="medium">
						{props.label}
						{props.required && "*"}
					</Typography>
				</label>
			)}
			</div>
			{hasErrors && (
				<div className={classes["errors-container"]}>
					{/* {errors.map((message, i) => ( */}
						<Typography type="p" size="small" weight="medium" color="error">
							{errors[0]}
						</Typography>
					{/* ))} */}
				</div>
			)}
		</div>
	);
}
